import React, { Component } from "react";

import {
  CCol,
  CRow,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSelect
} from "@coreui/react";
import { TriangleAlert } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { BookCard } from "./BookCard";
import { logout } from "../../../actions/baseActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import Loading from "../../Loading/index";

class DashboardAlunoOmni extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryColor: null,
      secondaryColor: null,
      grayColor: null,
      disciplines: [],
      discipline: null,
      Books: null,
      loading: true,
      roomInfo: []
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    const groupId = this.props.general.active_roles.group_id;
    const roleId = this.props.general.active_roles.role_id;

    const getUserRoomInfo = axios.get(
      `${URL.api}community/room_user/roomListUser`,
      {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      }
    );

    const getDashboardInfo = axios.get(
      `${URL.api}general/dashboard/which?group_id=${groupId}&role_id=${roleId}`,
      {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }
    );

    const getDisciplines = axios.get(
      `${URL.api}classification/discipline/list`,
      {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }
    );

    Promise.all([getUserRoomInfo, getDashboardInfo, getDisciplines])
      .then(([roomInfoResp, dashboardResp, disciplineGet]) => {
        let serieId = null;
        let series = null;

        if (roomInfoResp.data.data.rooms.length > 0) {
          if (roomInfoResp.data.data.rooms.length > 1) {
            let arr = [];
            roomInfoResp.data.data.rooms.forEach(item => {
              arr.push(item.serie_id);
            });
            series = arr;
          } else {
            serieId = roomInfoResp.data.data.rooms[0].serie_id;
          }
        }

        let books = JSON.parse(dashboardResp.data.data[0].json);
        if (serieId) {
          books = books.filter(
            item => Number(item.serie_id) === Number(serieId)
          );
        } else if (series) {
          books = books.filter(item => series.includes(Number(item.serie_id)));
        }

        books.sort((a, b) => a.serie_id - b.serie_id);

        const disciplinesToShow = disciplineGet.data.data.reduce(
          (acc, discipline) => {
            if (
              books.some(book => Number(book.discipline_id) === discipline.id)
            ) {
              acc.push(discipline);
            }
            return acc;
          },
          []
        );

        this.setState({
          Books: books,
          loading: false,
          roomInfo: roomInfoResp.data.data.rooms,
          disciplines: disciplinesToShow
        });
      })
      .catch(this.error);

    axios
      .get(`${URL.api}access/group/singleView/${groupId}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(respmodule => {
        this.setState({
          primaryColor: respmodule.data.data.group.primary,
          secondaryColor: respmodule.data.data.group.secondary,
          grayColor: respmodule.data.data.group.primary_grey
        });
      });
  }

  getBorder(item) {
    if (item.activity_percentage) return "light";
    if (Date.parse(item.activity_end) < Date.now()) return "danger";
    return "primary";
  }

  handleRedirect = url => {
    this.props.history.push(url);
  };

  render() {
    const root = document.documentElement;

    root?.style.setProperty(
      "--primary-group-change",
      this.state.primaryColor != null ? this.state.primaryColor : ""
    );
    root?.style.setProperty(
      "--secondary-group-change",
      this.state.secondaryColor != null ? this.state.secondaryColor : ""
    );
    root?.style.setProperty(
      "--primary-grey-group-change",
      this.state.grayColor != null ? this.state.grayColor : ""
    );

    const filteredDiscipline = this.state.disciplines.filter(
      discipline =>
        !this.state.discipline ||
        discipline.id === parseInt(this.state.discipline)
    );

    const BooksList =
      this.state.Books &&
      this.state.Books.filter(
        item =>
          !this.state.discipline || item.discipline_id === this.state.discipline
      );

    return (
      <>
        <div className="w-100">
          <CRow className="mb-3">
            <CCol xs="12">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h2 className="font-weight-bold text-title">Livros</h2>

                {this.state.roomInfo.length > 0 && (
                  <CInputGroup className="w-auto">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-book"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>

                    <CSelect
                      value={this.state.discipline}
                      onChange={e => {
                        this.setState({ discipline: e.target.value });
                      }}
                    >
                      <option value="">Selecione uma disciplina</option>
                      {this.state.disciplines.map(discipline => (
                        <option value={discipline.id} key={discipline.id}>
                          {discipline.name}
                        </option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                )}
              </div>
              <CRow>
                {this.state.loading ? (
                  <Loading />
                ) : (
                  <>
                    {this.state.roomInfo.length > 0 ? (
                      BooksList && BooksList.length > 0 ? (
                        BooksList.map((item, index) => (
                          <CCol
                            xs="6"
                            md="4"
                            lg="3"
                            xl="2"
                            className="mt-3"
                            key={index}
                          >
                            <BookCard
                              item={item}
                              onRedirect={this.handleRedirect}
                            />
                          </CCol>
                        ))
                      ) : (
                        <div className="justify-content-center align-items-center d-flex flex-column my-5 w-100">
                          <img
                            src={ImgNoData}
                            style={{ height: "240px", marginBottom: "2rem" }}
                            alt="No Data"
                          />
                          <p
                            style={{ fontSize: "1.5rem" }}
                            className="mb-2 font-weight-bold text-center"
                          >
                            Nada encontrado
                          </p>
                        </div>
                      )
                    ) : (
                      <div className="justify-content-center align-items-center d-flex flex-column my-5 w-100">
                        <TriangleAlert size="110px" />
                        <p
                          style={{ fontSize: "28px" }}
                          className="mb-2 font-weight-bold text-center"
                        >
                          Você não tem livros disponíveis
                        </p>
                      </div>
                    )}
                  </>
                )}
              </CRow>
            </CCol>
          </CRow>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardAlunoOmni);
